import { Box, Text } from '@usealloy/component-library';
import type { RiskRatingCardProps } from './RiskRatingCard';
import { FormulaTextWrapper } from './styles';

interface RiskRatingFormulaTextProps {
  riskFactors: RiskRatingCardProps['riskFactors'];
  riskOutputFormula: RiskRatingCardProps['riskOutputFormula'];
  riskValue: RiskRatingCardProps['riskValue'];
  canViewRiskFormula: boolean;
}

export const RiskRatingFormulaText = ({
  riskFactors,
  riskOutputFormula,
  riskValue,
  canViewRiskFormula,
}: RiskRatingFormulaTextProps) => (
  <FormulaTextWrapper alignItems="center" width="100%">
    <Box
      justifyContent="flex-start"
      direction="row"
      wrap="wrap"
    >
      {canViewRiskFormula && riskOutputFormula.map((formulaSegment, i) => {
        const riskFactor = riskFactors.find(({ name }) => (formulaSegment === name));
        if (
          typeof formulaSegment === 'string'
          && !!riskFactor
        ) {
          return (
            <Text key={`${i + 1}`} lineHeight={4} data-testid="risk-rating-formula-segment">
              {formulaSegment}(<b>{riskFactor.riskOutput}</b>)&nbsp;
            </Text>
          );
        }

        const displaySegment = typeof formulaSegment === 'string'
          && (formulaSegment.includes('[') || formulaSegment.includes(']'))
          ? formulaSegment.replace(/\[/g, '(').replace(/\]/g, ')')
          : formulaSegment;

        return <Text key={`${i + 1}`} lineHeight={4} data-testid="risk-rating-formula-segment">{displaySegment}&nbsp;</Text>;
      })}
    </Box>
    <Box
      direction="row"
      justifyContent="flex-start"
      width="100px"
      style={{
        padding: '0 var(--cl-space-3)', // shift the text to match the column padding
      }}
      data-testid="risk-rating-formula-result"
    >
      <Text lineHeight={4} weight={700}>=</Text>
      <Text lineHeight={4} style={{ marginLeft: 'var(--cl-space-2)' }} weight={700}>{riskValue}</Text>
    </Box>
  </FormulaTextWrapper>
);
